import { render, staticRenderFns } from "./NetDefault.vue?vue&type=template&id=13a00b29&scoped=true"
import script from "./NetDefault.vue?vue&type=script&lang=js"
export * from "./NetDefault.vue?vue&type=script&lang=js"
import style0 from "./NetDefault.vue?vue&type=style&index=0&id=13a00b29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a00b29",
  null
  
)

export default component.exports